<template>
    <div
        v-if="isShow && match.is_show"
        class="mb-4"
    >
        <div
            class="match-card"
            v-if="type !== 'history'"
        >
            <div class="match-header">
                <i class="fas fa-flag mr-2"></i>
                <span
                    class="match-title"
                    v-if="match.league"
                >{{ match.league }}</span>
            </div>

            <div class="match-body">
                <div
                    class="match-meta"
                    :class="match.is_big && $route.path !== '/maung-fb' ? 'active' : ''"
                >
                    <div class="match-date">
                        <i class="far fa-star mr-1"></i>
                        <p>{{ betDate(match.start_time) }}</p>
                    </div>
                    <div class="match-time">
                        <i class="far fa-clock mr-1"></i>
                        <p>{{ betTime(match.start_time) }}</p>
                    </div>
                </div>

                <div class="match-content">
                    <div class="team-row">
                        <div
                            class="team"
                            :class="((betMatch.selected_team === match.first_team) && (!isGoalPor && !isSoneMa))
                                ? 'active'
                                : null
                                "
                            @click="
                                type === 'history'
                                    ? ''
                                    : checkTeam(match.first_team, null, match.first_team_id)
                                "
                        >
                            <div>
                                <!-- <img
                                    src="https://assets.b365api.com/images/team/m/4828.png"
                                    alt="team_1_logo"
                                > -->
                                <b :class="match.kyayed_team === match.first_team ? 'active' : ''">
                                    {{ match.first_team }}
                                </b>
                            </div>
                            <div
                                class="bet-odds"
                                v-if="
                                    match.kyayed_team === match.first_team &&
                                    !isKyayHistory
                                "
                            >
                                {{
                                    getFBOrder.type === "maung"
                                        ? match.maung_kyay === "~"
                                            ? "=="
                                            : match.maung_kyay
                                        : match.body_kyay === "~"
                                            ? "=="
                                            : match.body_kyay
                                }}
                            </div>
                        </div>
                        <div
                            class="bet-option"
                            :class="((betMatch.selected_team === match.first_team) && isGoalPor)
                                ? 'active'
                                : null
                                "
                            v-if="!isKyayHistory"
                            @click="
                                type === 'history'
                                    ? ''
                                    : checkTeam(match.first_team, 'up', match.first_team_id)
                                "
                        >
                            <span>ဂိုးပေါ်</span>
                        </div>
                    </div>
                    <div class="bet-odds absolute">
                        <div
                            @click="type === 'history' ? '' : changeGoalPor()"
                            v-if="isKyayHistory"
                        >
                            {{
                                getFBOrder.type === "maung"
                                    ? history.maung_goal_kyay
                                    : history.body_goal_kyay
                            }}
                        </div>
                        <div
                            @click="type === 'history' ? '' : changeGoalPor()"
                            v-else
                        >
                            {{
                                getFBOrder.type === "maung"
                                    ? match.maung_goal_kyay
                                    : match.body_goal_kyay
                            }}
                        </div>
                    </div>

                    <div class="team-row">
                        <div
                            class="team"
                            :class="((betMatch.selected_team === match.second_team) && (!isGoalPor && !isSoneMa))
                                ? 'active'
                                : null
                                "
                            @click="
                                type === 'history'
                                    ? ''
                                    : checkTeam(match.second_team, null, match.second_team_id)
                                "
                        >
                            <div>
                                <!-- <img
                                    src="https://assets.b365api.com/images/team/m/4766.png"
                                    alt="team_2_logo"
                                > -->
                                <b :class="match.kyayed_team === match.second_team ? 'active' : ''">
                                    {{ match.second_team }}
                                </b>
                            </div>
                            <div
                                class="bet-odds"
                                v-if="
                                    match.kyayed_team === match.second_team &&
                                    !isKyayHistory
                                "
                            >
                                {{
                                    getFBOrder.type === "maung"
                                        ? match.maung_kyay === "~"
                                            ? "=="
                                            : match.maung_kyay
                                        : match.body_kyay === "~"
                                            ? "=="
                                            : match.body_kyay
                                }}
                            </div>
                        </div>
                        <div
                            class="bet-option"
                            :class="((betMatch.selected_team === match.second_team) && isGoalPor)
                                ? 'active'
                                : null
                                "
                            v-if="!isKyayHistory"
                            @click="
                                type === 'history'
                                    ? ''
                                    : checkTeam(match.second_team, 'down', match.second_team_id)
                                "
                        >ဂိုးအောက်</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- history team card -->
        <div
            v-if="type === 'history'"
            class="match-container mb-2"
        >
            <div
                class="upper-card w-100 d-flex justify-content-around"
                style="height: 40px"
            >
                <!-- style="width: calc(50% - 100px)" -->
                <div
                    class="upper-left-card d-flex"
                    style="width: calc(50% - 40px)"
                    :class="betMatch.selected_team === match.first_team
                        ? 'active'
                        : null
                        "
                    @click="
                        type === 'history'
                            ? ''
                            : checkTeam(match.first_team, 'up', match.first_team_id)
                        "
                >
                    <span
                        class="my-auto mx-auto"
                        style=""
                    >
                        <!-- <b
                            >{{ firstMatchNo() }}.{{ match.first_team }}</b
                        > -->
                        <b>{{
                            $store.state.language === "en"
                                ? match.first_team_en
                                : match.first_team
                        }}</b>
                    </span>
                </div>
                <div
                    class="d-flex"
                    v-if="isGoalPor"
                >
                    <i
                        style="font-size: 20px; color: red; margin-right: 2px"
                        class="fas fa-long-arrow-alt-up my-auto"
                    ></i>
                </div>
                <div
                    class="upper-middle-card d-flex justify-content-center"
                    style="width: 80px"
                >
                    <!-- <div>
                        <img
                            src="https://via.placeholder.com/35"
                            class="team-image"
                            alt=""
                        />
                    </div> -->
                    <div
                        class="text-center px-1"
                        :class="type === 'history' ? 'd-flex' : ''"
                        style="
                            width: 80px;
                        "
                    >
                        <!-- 0:0 -->
                        <div v-if="type !== 'history'"><b>Close</b></div>
                        <div v-if="type !== 'history'">
                            <!-- {{ match.close_time.hh }} :
                            {{ match.close_time.mm }} {{ match.close_time.A }} -->
                        </div>
                        <div
                            v-if="type === 'history'"
                            class="text-danger mx-auto my-auto"
                        >
                            <h2>
                                {{
                                    match.first_team_result +
                                    " : " +
                                    match.second_team_result
                                }}
                            </h2>
                        </div>
                    </div>
                    <!-- <div>
                        <img
                            src="https://via.placeholder.com/35"
                            class="team-image"
                            alt=""
                        />
                    </div> -->
                </div>
                <div
                    class="d-flex"
                    v-if="isGoalPor"
                >
                    <i
                        style="font-size: 20px; color: red; color: red; margin-left: 2px"
                        class="fas fa-long-arrow-alt-down my-auto"
                    ></i>
                </div>
                <div
                    class="upper-right-card d-flex"
                    style="width: calc(50% - 40px)"
                    :class="betMatch.selected_team === match.second_team
                        ? 'active'
                        : null
                        "
                    @click="
                        type === 'history'
                            ? ''
                            : checkTeam(match.second_team, 'down', match.second_team_id)
                        "
                >
                    <span class="text-center my-auto mx-auto">
                        <!-- <b
                            >{{ secondMatchNo() }}.{{ match.second_team }}</b
                        > -->
                        <b>{{
                            $store.state.language === "en"
                                ? match.second_team_en
                                : match.second_team
                        }}</b>
                    </span>
                </div>
            </div>
            <div
                class="lower-card w-100 d-flex p-1 justify-content-center"
                style="height: 40px"
            >
                <div class="d-flex kyay-left pt-1">
                    <div
                        class="mx-auto"
                        style="font-size: 15px; color: red"
                        v-if="
                            match.kyayed_team === match.first_team &&
                            !isKyayHistory
                        "
                    >
                        {{
                            getFBOrder.type === "maung"
                                ? match.maung_kyay === "~"
                                    ? "=="
                                    : match.maung_kyay
                                : match.body_kyay === "~"
                                    ? "=="
                                    : match.body_kyay
                        }}
                    </div>
                    <div
                        class="mx-auto"
                        style="font-size: 15px; color: red"
                        v-if="
                            match.kyayed_team === match.first_team &&
                            isKyayHistory
                        "
                    >
                        {{
                            getFBOrder.type === "maung"
                                ? history.maung_kyay === "~"
                                    ? "=="
                                    : history.maung_kyay
                                : history.body_kyay === "~"
                                    ? "=="
                                    : history.body_kyay
                        }}
                    </div>
                </div>
                <div
                    style="
                        width: 70px;
                        background: #0F8606;
                        border-radius: 3px;
                        font-size: 15px;
                    "
                    class="text-center pt-1 text-danger text-white"
                    @click="type === 'history' ? '' : changeGoalPor()"
                    v-if="isKyayHistory"
                >
                    Gp{{
                        getFBOrder.type === "maung"
                            ? history.maung_goal_kyay
                            : history.body_goal_kyay
                    }}
                </div>
                <div
                    style="
                        width: 70px;
                        background: #0F8606;
                        border-radius: 3px;
                        font-size: 15px;
                    "
                    class="text-center pt-1 text-danger text-white"
                    @click="type === 'history' ? '' : changeGoalPor()"
                    v-else
                >
                    Gp{{
                        getFBOrder.type === "maung"
                            ? match.maung_goal_kyay
                            : match.body_goal_kyay
                    }}
                </div>
                <div
                    class="d-flex kyay-right"
                    style="width: calc(50%-25px)"
                >
                    <div
                        class="mx-auto"
                        style="font-size: 15px; color: red"
                        v-if="
                            match.kyayed_team === match.second_team &&
                            !isKyayHistory
                        "
                    >
                        {{
                            getFBOrder.type === "maung"
                                ? match.maung_kyay === "~"
                                    ? "=="
                                    : match.maung_kyay
                                : match.body_kyay === "~"
                                    ? "=="
                                    : match.body_kyay
                        }}
                    </div>
                    <div
                        class="mx-auto"
                        style="font-size: 15px; color: red"
                        v-if="
                            match.kyayed_team === match.second_team &&
                            isKyayHistory
                        "
                    >
                        {{
                            getFBOrder.type === "maung"
                                ? history.maung_kyay === "~"
                                    ? "=="
                                    : history.maung_kyay
                                : history.body_kyay === "~"
                                    ? "=="
                                    : history.body_kyay
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    props: {
        match: Object,
        history: Object,
        type: String,
        onMyEvent: Function,
        isKyayHistory: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            targetTimeZone: 'Asia/Yangon',
            currentTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            isGoalPor: false,
            isSoneMa: false,
            interval: null,
            isShow: true,
            isLast: false,
            betMatch: {},
            isSelect: false,
        };
    },
    computed: {
        ...mapGetters(['getFBOrder']),
    },
    methods: {
        betTime(time) {
            return moment(new Date(time)).format('hh:mm A');
        },
        betDate(time) {
            return moment(new Date(time)).format('DD-MM-YYYY');
        },

        firstMatchNo() {
            return this.match.match_no * 2 - 1;
        },
        secondMatchNo() {
            return this.match.match_no * 2;
        },
        ...mapMutations(['setFBMatches', 'updateFBMatches', 'removeFBMatch', 'setWholeFBMatches']),
        checkTeam(selectedTeam, goalUpDown = null, selectedTeamId = null, soneMa = null) {
        const matchIndex = this.getFBOrder.fb_matches.findIndex(
            (match) => match.id === this.match.id,
        );

        if (selectedTeam === this.betMatch.selected_team) {
            this.betMatch = {};
            this.removeFBMatch(matchIndex);
            return false;
        }

        if(this.type === 'body') {
            this.setWholeFBMatches([])
            this.$emit('removeMatches')
        }

        this.betMatch = {};
        this.betMatch = this.match;
        this.betMatch.selected_team = selectedTeam;
        this.betMatch.selected_team_id = selectedTeamId;
        if (goalUpDown && !soneMa) {
            this.betMatch.goal_up_down = goalUpDown;
            this.isGoalPor = true;
            this.isSoneMa = null;
            this.betMatch.sone_ma = null;
        } else if (!goalUpDown && soneMa) {
            this.betMatch.sone_ma = soneMa;
            this.isSoneMa = true;
            this.isGoalPor = null;
            this.betMatch.goal_up_down = null;
        } else {
            this.isGoalPor = null;
            this.betMatch.goal_up_down = null;
            this.isSoneMa = null;
            this.betMatch.sone_ma = null;
        }
        this.betMatch.selected_score = null;
        this.betMatch.selected_kyay = null;

        this.betMatch.correct_score = null;
        this.betMatch.correct_odds = null;

        if (matchIndex === -1) this.setFBMatches(this.betMatch);
        else {
            this.updateFBMatches({
            index: matchIndex,
            value: this.betMatch,
            });
        }
        return true;
        },
        changeGoalPor() {
            this.isGoalPor = !this.isGoalPor;
            this.checkFBMatchTime();
        },
        checkFBMatchTime() {
            const matchTime = new Date(this.match.start_time);
            const nowTime = new Date();
            this.isShow = matchTime > nowTime;
            if (!this.isShow) {
                const index = this.getFBOrder.fb_matches.findIndex((match) => match.id === this.match.id)
                if (index !== -1) {
                    let newDatas = JSON.parse(JSON.stringify(this.getFBOrder.fb_matches));
                    newDatas.splice(index, 1);
                    this.setWholeFBMatches(newDatas);
                }
            }
        },
    },
    destroyed() {
        clearInterval(this.interval);
    },
    unmounted() {
        clearInterval(this.interval);
    },
    mounted() {
        // this.currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.onMyEvent(() => {
            this.betMatch = {};
        });
        if (this.type !== 'history') {
            this.checkFBMatchTime();
            this.interval = setInterval(() => this.checkFBMatchTime(), 3000);
        }
    },
};
</script>

<style scoped>
.match-card {
    background: #fcfcfc;
    box-shadow:
        3px 3px 6px rgba(0, 0, 0, 0.1),
        /* subtle right-bottom shadow */
        -3px -3px 6px rgba(0, 0, 0, 0.08);
    border-radius: 0.75rem;
    color: #334155;
    overflow: hidden;
}

/* Header */
.match-header {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 16px;
    padding: 0.5rem;
    background: transparent;
}

.match-icon {
    width: 1em;
    height: 1em;
}

.match-title {
    font-weight: 600;
}

/* Body */
.match-body {
    background: white;
    border-radius: 0.75rem;
}

/* Match Meta (date + time) */
.match-meta {
    display: flex;
    justify-content: space-between;
    background: #4ade80;
    color: rgb(51 65 85/1);
    padding: 0.25rem 0.5rem;
}

.match-meta.active {
    color: white;
    background: #087F9F;
}

.match-date,
.match-time {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.match-date p,
.match-date i,
.match-time p,
.match-time i {
    margin-bottom: 0;
    font-weight: bold;
}

.meta-icon {
    font-size: 1.2rem;
}

/* Content */
.match-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
}

.team-row {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
}

.match-content .team-row:first-child {
    border-bottom: 1px solid rgb(203 213 225/1);
}

.team img {
    width: 32px;
    height: 32px;
    margin-right: 0.5rem;
}

.team {
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    width: 100%;
    padding: .5rem;
    border-right: 1px solid rgb(203 213 225/1);
}

.team.active,
.bet-option.active {
    background: #f69e57;
    color: white !important;
}

.bet-option {
    position: relative;
    min-width: 100px;
    max-width: 120px;
    text-align: center;
    font-weight: 600;
    font-size: 13px;
    padding: 0.5rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.bet-odds {
    background: #475569;
    color: white;
    font-weight: 600;
    border: 1px solid white;
    font-size: 12px;
    text-align: center;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
}

.bet-odds.absolute {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 5;
}



.big-match-design {
    /* border-width: 3px !important;
    border-style: solid !important;
  border-radius: 5px !important; */
    background: rgb(177, 176, 176) !important;
    border: none !important;
    /* color: white !important; */
}

.goal-por {
    text-align: center;
}

.goal-por,
.goal-por {
    background: #575757;
    color: white;
    border-radius: 3px;
    margin-right: 100px;
    padding-bottom: 5px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    width: 100%;
    height: 34px !important;
    font-size: 12px !important;
}

.goal-por:active,
.goal-por.active {
    /* background-image: linear-gradient(#ffffff, #F68E56); */
    background: #f69e57;
    color: white !important;
}

.kyay-left,
.kyay-right {
    width: calc(50% - 30px);
    margin: 0px;
}

.kyay-left {
    margin-right: 5px;
}

.kyay-right {
    margin-left: 5px;
}

.team-image {
    width: 35px;
    height: 35px;
    border-radius: 3px;
    margin: 3px;
}

.match-container {
    /* border: 1px solid rgb(191, 190, 190); */
    border-radius: 5px;
    background: #cccccc !important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

/* .lower-card {
    border-top: 1px solid rgb(220, 217, 217);
} */
hr {
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
}

.upper-right-card,
.upper-left-card,
.upper-right-card,
.upper-left-card {
    background: #575757;
    color: white;
    border-radius: 3px;
    margin-top: 3px;
    /* margin-left: 3px;
    margin-right: 3px; */
    margin-bottom: 3px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}

.upper-right-card {
    margin-left: 3px;
    margin-right: 3px;
}

.upper-left-card {
    margin-left: 3px;
    margin-right: 3px;
}

.upper-right-card:active,
.upper-left-card:active,
.upper-right-card.active,
.upper-left-card.active {
    background-image: linear-gradient(#ffffff, #F68E56);
    color: black;
    border-radius: 3px;
    margin-top: 3px;
    /* margin-left: 3px;
    margin-right: 3px; */
    margin-bottom: 3px;
}
</style>
